// src/rtl-cache.ts
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';

// This Emotion cache will auto‑flip all left/right styles for RTL
export default createCache({
  key: 'mui-rtl',
  stylisPlugins: [rtlPlugin],
});
